var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollaborators(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "colored",
    d: "M12.5 8.49609C14.8461 8.49609 16.748 6.59418 16.748 4.24805C16.748 1.90192 14.8461 0 12.5 0C10.1539 0 8.25195 1.90192 8.25195 4.24805C8.25195 6.59418 10.1539 8.49609 12.5 8.49609Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "colored",
    d: "M21.0938 8.4961C22.5769 8.4961 23.7793 7.29374 23.7793 5.81055C23.7793 4.32736 22.5769 3.125 21.0938 3.125C19.6106 3.125 18.4082 4.32736 18.4082 5.81055C18.4082 7.29374 19.6106 8.4961 21.0938 8.4961Z",
    fill: "#4A4A4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "colored",
    d: "M3.90625 8.4961C5.38944 8.4961 6.5918 7.29374 6.5918 5.81055C6.5918 4.32736 5.38944 3.125 3.90625 3.125C2.42306 3.125 1.2207 4.32736 1.2207 5.81055C1.2207 7.29374 2.42306 8.4961 3.90625 8.4961Z",
    fill: "#4A4A4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "colored",
    d: "M6.55225 10.9069C5.49512 10.0408 4.53774 10.1554 3.31543 10.1554C1.4873 10.1554 0 11.6339 0 13.4508V18.7833C0 19.5724 0.644043 20.214 1.43604 20.214C4.85527 20.214 4.44336 20.2759 4.44336 20.0665C4.44336 16.2879 3.9958 13.5169 6.55225 10.9069Z",
    fill: "#4A4A4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "colored",
    d: "M13.6626 10.1768C11.5277 9.99868 9.67195 10.1788 8.07131 11.5C5.39275 13.6455 5.90822 16.5343 5.90822 20.0684C5.90822 21.0034 6.66897 21.7783 7.61819 21.7783C17.9249 21.7783 18.3351 22.1108 18.9463 20.7573C19.1468 20.2996 19.0918 20.4451 19.0918 16.0664C19.0918 12.5886 16.0804 10.1768 13.6626 10.1768Z",
    fill: "#4A4A4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "colored",
    d: "M21.6846 10.1553C20.4556 10.1553 19.5035 10.0418 18.4478 10.9068C20.9851 13.4974 20.5566 16.0794 20.5566 20.0664C20.5566 20.2771 20.2147 20.2139 23.5127 20.2139C24.333 20.2139 25 19.5493 25 18.7324V13.4507C25 11.6338 23.5127 10.1553 21.6846 10.1553Z",
    fill: "#4A4A4A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaborators);
export default __webpack_public_path__ + "static/media/collaborators.fb953431.svg";
export { ForwardRef as ReactComponent };